import { BlackListWrapper } from "../../pages/CheckOut/CheckOut";
import CheckOutButtons from "../../pages/CheckOut/CheckOutButtons";
import { handleCopy } from "../../utilities/copyHandler";
import { baseName } from "../../settings";
import { ReactComponent as Link } from "../../assets/icons/link.svg";
import CheckOutList from "../CheckOutList/CheckOutList";
import "./CheckOutTime.css";
import { useMemo, useEffect, useState, useContext, useRef } from "react";
import {
  delete_cookie,
  getCookie,
  setCookie
} from "../../utilities/cookieManager";
import { settings } from "../../state_management/actionTypes";
import { connect } from "react-redux";
import { stateType } from "../../store";
import {
  orderInfo,
  orderType,
  section_array
} from "../../state_management/reducers/order";
import { setOrderDetails } from "../../state_management/actions";
import { parseIdQuan } from "../../state_management/epics/order";
import { getMinsTotal, inPast } from "../../utilities/cleanerTime";
import { cartItem, extrasCartItem } from "../../state_management/reducers/cart";
import {
  setAddressBlacklisted,
  setPageCount
} from "../../state_management/actions/common";
import { language } from "../../settings";
import CheckOutSection from "./CheckOutSection";
import { useTimeDetails } from "../../utilities/timeDetails";
import { only_gift } from "../../utilities/cartUtilities";
import { LocaleContext } from "../../AppProvider";
import { stripEircodeFromAddress } from "../../utilities/misc";
import AuthService from "../../utilities/accountAuth";
import { getLastBooking } from "../../state_management/epics/account";

// load google map api js
const apiKey = `AIzaSyCLVReJTrsUwkRCzYjmhmhzZTui_coLVF0`;
const mapApiJs = "https://maps.googleapis.com/maps/api/js";

export const addressCookieKey = "cleanBee_checkout_address";
export const eircodeCookieKey = "cleanBee_checkout_address_eircode";
const latCookieKey = "cleanBee_checkout_address_lat";
const lngCookieKey = "cleanBee_checkout_address_lng";

function loadAsyncScript(src: string) {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    Object.assign(script, {
      type: "text/javascript",
      async: true,
      src
    });
    script.addEventListener("load", () => resolve(script));
    document.head.appendChild(script);
  });
}

const employee_list_id = `cleaner_list_wrapper_id`;

export const scrollToTimeBlock = () => {
  const timeBlock =
    document.getElementById("checkout_time_block") ||
    document.getElementById("checkout_time_slots") ||
    document.querySelector(".calendar_content") ||
    document.querySelector(".checkoutTimeWrapper");

  if (!timeBlock) return;

  const rect = timeBlock.getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;

  // Only scroll if the time block is not already comfortably visible in the viewport
  const isTopVisible = rect.top >= 0 && rect.top <= windowHeight * 0.75;

  if (!isTopVisible) {
    timeBlock.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

const CheckOutTime = ({
  orderDetails,
  setOrderDetails,
  cart,
  extras,
  hide,
  checkoutError,
  orderInfo,
  addressBlacklisted,
  setAddressBlacklisted,
  settings,
  setPageCount,
  pageCount
}: {
  orderDetails: orderType;
  setOrderDetails: (details: Partial<orderType>) => void;
  cart: cartItem[];
  extras: extrasCartItem[];
  hide: boolean;
  checkoutError: boolean;
  orderInfo: orderInfo;
  addressBlacklisted: boolean;
  setAddressBlacklisted: (data: boolean) => void;
  settings: Partial<settings>;
  setPageCount: (data: number) => void;
  pageCount: number;
}) => {
  const onlyGift = only_gift({ cart, extras });
  useEffect(() => {
    if (onlyGift) {
      setPageCount(section_array[0]);
    }
  }, [onlyGift]);
  const { t, locale } = useContext(LocaleContext);
  const [copied, setCopied] = useState(false);
  const mountedRef = useRef(true);
  const [timeoutId, setTimeoutId] = useState<number | null>(null);

  useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const orderDetailsRef = useRef(orderDetails);
  useEffect(() => {
    orderDetailsRef.current = orderDetails;
  }, [orderDetails]);

  useEffect(() => {
    if (checkoutError && !orderDetails.time_start && !hide) {
      scrollToTimeBlock();
    }
  }, [checkoutError, orderDetails.time_start, hide]);

  const generateCartUrl = () => {
    const cStr = cart.map(c => `${c.item.id}-${c.quantity}-${c.is_upsell ? 1 : 0}`).join(',');
    const eStr = extras.map(e => `${e.item.id}-${e.quantity}-${e.parent_id}`).join(',');
    
    let url = `${window.location.origin}${baseName}/checkout?c=${cStr}`;
    if (eStr) url += `&e=${eStr}`;

    if (orderDetails.client_address) url += `&address=${encodeURIComponent(orderDetails.client_address)}`;
    if (orderDetails.latitude) url += `&lat=${orderDetails.latitude}`;
    if (orderDetails.longitude) url += `&lng=${orderDetails.longitude}`;
    if (orderDetails.eircode) url += `&eircode=${encodeURIComponent(orderDetails.eircode)}`;
    
    if (orderDetails.time_start) url += `&time_start=${encodeURIComponent(orderDetails.time_start)}`;
    if (orderDetails.cleaner_id) url += `&cleaner_id=${orderDetails.cleaner_id}`;
    if (orderDetails.random_cleaner === false) url += `&random_cleaner=false`;

    return url;
  };

  const cartUrlLinkJSX = (
    <div
      onClick={() => {
        handleCopy(generateCartUrl(), () => {
          if (timeoutId) clearTimeout(timeoutId);
          setCopied(true);
          const copyTimeout = window.setTimeout(() => {
            if (mountedRef.current) setCopied(false);
          }, 3000);
          setTimeoutId(copyTimeout);
        });
      }}
      className="copy_link_wrapper"
    >
      <div className="copy_link_icon">
        <Link className="img_div_contain" />
      </div>
      <div className="copy_link_container flex1">
        <span className="fontBlue">
          {t("Copy my cart link for someone else to complete" as any) as string}
        </span>
        <div className={`copyNotif ${!copied ? `hideNotif` : ``}`}>
          {t("Copied" as any) as string}
        </div>
      </div>
    </div>
  );

  const orderWindow = settings.order_creation_before_interval;
  const address_field_id = "checkout__address_field__ID";
  const [address, setAddress] = useState<string>(
    getCookie(addressCookieKey) || orderDetails.client_address || ""
  );
  const [latitude, setLatitude] = useState<number | undefined>(
    parseFloat(getCookie(latCookieKey)) || orderDetails.latitude || undefined
  );
  const [longitude, setLongitude] = useState<number | undefined>(
    parseFloat(getCookie(lngCookieKey)) || orderDetails.longitude || undefined
  );
  const [eircode, setEircode] = useState<string | undefined>(
    getCookie(eircodeCookieKey) || orderDetails.eircode || undefined
  );

  const initMapScript = () => {
    // if script already loaded
    if (window.google && window.google.maps && window.google.maps.places) {
      return Promise.resolve();
    }

    // @ts-ignore
    window.mapInitCallback = function (param: any) {};
    const src = `${mapApiJs}?key=${apiKey}&libraries=places&language=${language}&v=weekly&callback=mapInitCallback`;
    return loadAsyncScript(src);
  };

  const hasSyncedOrderDetails = useRef(false);

  // Sync hydrated address data exactly once when it arrives
  useEffect(() => {
    if (orderDetails.client_address && !hasSyncedOrderDetails.current) {
      hasSyncedOrderDetails.current = true;

      setAddress(orderDetails.client_address);
      setLatitude(orderDetails.latitude || undefined);
      setLongitude(orderDetails.longitude || undefined);
      setEircode(orderDetails.eircode || undefined);

      // Save to cookies to persist across reloads
      setCookie(addressCookieKey, orderDetails.client_address);
      if (orderDetails.latitude) setCookie(latCookieKey, `${orderDetails.latitude}`);
      if (orderDetails.longitude) setCookie(lngCookieKey, `${orderDetails.longitude}`);
      if (orderDetails.eircode) setCookie(eircodeCookieKey, orderDetails.eircode);
      
      // Also update the input if it's already rendered
      const input = document.getElementById(address_field_id) as HTMLInputElement | null;
      if (input) {
        input.value = orderDetails.client_address;
      }
    }
  }, [orderDetails.client_address]);

  // If already authenticated and we don't have an address yet, try fetching from the last booking
  useEffect(() => {
    const tryFetchLastBooking = async () => {
      const token = AuthService.getAuthToken();
      if (token && !address && !getCookie(addressCookieKey)) {
        const lastBooking = await getLastBooking();
        if (lastBooking?.address?.address) {
          const client_address = lastBooking.address.address;
          const eircodeVal = lastBooking.address.eircode;
          const latVal = lastBooking.address.latitude;
          const lngVal = lastBooking.address.longitude;
          setOrderDetails({
            client_address,
            eircode: eircodeVal,
            latitude: latVal,
            longitude: lngVal
          });
          setAddress(client_address);
          if (eircodeVal) setEircode(eircodeVal);
          if (latVal) setLatitude(latVal);
          if (lngVal) setLongitude(lngVal);
          
          setCookie(addressCookieKey, client_address);
          if (eircodeVal) setCookie(eircodeCookieKey, eircodeVal);
          if (latVal) setCookie(latCookieKey, `${latVal}`);
          if (lngVal) setCookie(lngCookieKey, `${lngVal}`);
        }
      }
    };
    tryFetchLastBooking();
  }, []);

  const [mapLoaded, setMapLoaded] = useState(false);

  // Fallback: If we somehow have an address but no coordinates, geocode it silently
  useEffect(() => {
    if (mapLoaded && address && !latitude && !longitude && window.google && window.google.maps) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address }, (results, status) => {
        if (status === "OK" && results && results.length > 0) {
          const lat = results[0].geometry.location.lat();
          const lng = results[0].geometry.location.lng();
          
          setLatitude(lat);
          setLongitude(lng);
          setOrderDetails({ latitude: lat, longitude: lng });
          
          setCookie(latCookieKey, `${lat}`);
          setCookie(lngCookieKey, `${lng}`);
        }
      });
    }
  }, [address, latitude, longitude, mapLoaded]);

  // do something on address change
  const onChangeAddress = (autocomplete: google.maps.places.Autocomplete) => {
    const place = autocomplete.getPlace();
    const lat = place.geometry?.location?.lat() || undefined;
    const lng = place.geometry?.location?.lng() || undefined;
    let eircode = "";
    if (place.address_components) {
      const postalCodeComponent = place.address_components.find((component) =>
        component.types.includes("postal_code")
      );
      if (postalCodeComponent) {
        eircode = postalCodeComponent.long_name; // This holds the Eircode string
      }
    }

    const input = document.getElementById(address_field_id) as
      | HTMLInputElement
      | undefined;
    
    let finalAddress = stripEircodeFromAddress(input?.value, eircode);

    handleAddress({ lat, lng, eircode, address: finalAddress });
  };

  // init autocomplete
  const initAutocomplete = () => {
    const input = document.getElementById(address_field_id) as
      | HTMLInputElement
      | undefined;
    if (!input) return;

    if (input) {
      if (!input.value) {
        input.value = address || "";
      }
    }

    if (!window.google || !window.google.maps || !window.google.maps.places) {
      return;
    }

    const country = locale === "eng" ? ["ie", "gb"] : "lt";

    const options = {
      fields: ["formatted_address", "geometry", "address_components"],
      types: ["geocode"],
      componentRestrictions: { country },
      bounds:
        locale === "eng"
          ? new window.google.maps.LatLngBounds(
              new window.google.maps.LatLng(51.3, -10.7),
              new window.google.maps.LatLng(55.5, -5.3)
            )
          : undefined,
      strictBounds: true
    };

    const autocomplete = new window.google.maps.places.Autocomplete(
      input,
      options
    );

    autocomplete.addListener("place_changed", () =>
      onChangeAddress(autocomplete)
    );
  };

  // load map script after mounted
  useEffect(() => {
    initMapScript().then(() => {
      initAutocomplete();
      setMapLoaded(true);
    });
  }, [hide]);

  const [openEmployee, setOpenEmployee] = useState(false);

  const {
    serviceDuration,
    addressBlackListCheckRes,
    availableTimeRes,
    cleaners,
    date,
    disabledDateObj,
    disabledDatesRes,
    timeArray,
    cleanerError,
    setMonth,
    setDate,
    timeDetailsError,
    noCleanerLocationError
  } = useTimeDetails({
    address,
    hide,
    checkout: true,
    latitude,
    longitude,
    orderDetails,
    eircode,
    setAddressBlacklisted,
    setOrderDetails,
    services: cart.map((item) => ({
      type: "typical",
      duration: item.item.duration,
      extra: false,
      ...parseIdQuan({ item, extra: false })
    })),
    extra_services: extras.map((item) => ({
      type: "extra",
      duration: item.item.duration,
      extra: true,
      ...parseIdQuan({ item, extra: true })
    }))
  });

  useEffect(() => {
    if (hide) return; // Don't wipe time_start when the Time step is not visible
    const past = inPast(
      date || orderDetails.time_start || undefined,
      getMinsTotal(orderDetails.time_start || ""),
      orderWindow || 0
    );

    if (past) {
      setOrderDetails({
        time_start: null
      });
    }
  }, [date, orderDetails.time_start, orderDetails.cleaner_id, hide]);

  useEffect(() => {
    const outsideClick = (e: MouseEvent) => {
      const element = document.getElementById(employee_list_id);
      if (element && !element.contains(e.target as Node)) {
        setOpenEmployee(false);
      }
    };

    document.addEventListener("click", outsideClick);

    return () => {
      document.removeEventListener("click", outsideClick);
    };
  }, []);

  const clearAddress = () => {
    const inputField = document.getElementById(address_field_id) as
      | HTMLInputElement
      | undefined;
    if (inputField) {
      inputField.value = "";
    }
    setAddress("");
    setLatitude(undefined);
    setLongitude(undefined);
    setEircode(undefined);

    delete_cookie(addressCookieKey);
    delete_cookie(latCookieKey);
    delete_cookie(lngCookieKey);
    delete_cookie(eircodeCookieKey);
  };

  const handleAddress = (details: {
    address: string | undefined;
    eircode: string;
    lng: number | undefined;
    lat: number | undefined;
  }) => {
    let { address, lat, lng, eircode } = details;
    address = address || "";
    setAddress(address);
    setLatitude(lat ?? undefined);
    setLongitude(lng ?? undefined);

    setCookie(addressCookieKey, address);
    setCookie(latCookieKey, `${lat}`);
    setCookie(lngCookieKey, `${lng}`);

    const eircodeRegex = new RegExp(/^[A-Z][0-9][0-9]\s?[A-Z0-9]{4}$/);
    if (eircodeRegex.test(eircode)) {
      setEircode(eircode);
      setCookie(eircodeCookieKey, eircode);
    } else {
      setEircode(undefined);
      delete_cookie(eircodeCookieKey);
    }
  };

  const cleaner = useMemo(() => {
    const worker_obj =
      cleaners?.find((obj) => obj.id === orderDetails.cleaner_id) || null;
    if (worker_obj) {
      return `${worker_obj.firstname} ${worker_obj.lastname}`;
    } else {
      return ``;
    }
  }, [orderDetails.cleaner_id, cleaners]);

  const timeError = (): string => {
    let errorMsg = "";
    if (!date) {
      errorMsg = t("Please select a date and time for your cleaning");
    } else if (!orderDetails.time_start) {
      errorMsg = t("Please select a time for your cleaning");
    }

    return errorMsg;
  };

  const loading = addressBlackListCheckRes.loading;
  const error = addressBlackListCheckRes.error;

  return hide ? (
    <div />
  ) : (
    <div className="checkOutList_wrapper checkoutTimeWrapper">
      <BlackListWrapper
        listObjects={[
          {
            inView: addressBlacklisted,
            text: error ? error : t("Address is blacklisted"),
            watch: !!(!loading && error && addressBlacklisted)
          },
          {
            inView: !!timeDetailsError,
            text: timeDetailsError || "",
            watch: true
          },
          {
            inView: !!noCleanerLocationError,
            text: noCleanerLocationError || "",
            watch: true
          }
        ]}
      />
      <CheckOutSection
        reschedule={false}
        address={address}
        orderDetails={orderDetails}
        address_field_id={address_field_id}
        clearAddress={clearAddress}
        setOpenEmployee={setOpenEmployee}
        openEmployee={openEmployee}
        orderInfo={orderInfo}
        setOrderDetails={setOrderDetails}
        serviceDuration={serviceDuration}
        Buttons={
          <>
            <CheckOutButtons
              loading={addressBlackListCheckRes.loading}
              disabled={addressBlackListCheckRes.loading}
            />
            <div className="showSm" style={{ marginTop: '20px' }}>
              {cartUrlLinkJSX}
            </div>
          </>
        }
        Errors={
          <>
            {checkoutError &&
            orderDetails.client_address &&
            !orderDetails.random_cleaner &&
            !orderDetails.cleaner_id ? (
              <span className="showSm errorMsg">
                {t("Please select a cleaner")}
              </span>
            ) : (
              ``
            )}
            {checkoutError &&
            orderDetails.client_address &&
            !orderDetails.time_start &&
            timeError() ? (
              <span className="showSm errorMsg">{timeError()}</span>
            ) : (
              ``
            )}
          </>
        }
        employee_list_id={employee_list_id}
        addressBlackListCheckRes={addressBlackListCheckRes}
        availableTimeRes={availableTimeRes}
        disabledDatesRes={disabledDatesRes}
        cleaners={cleaners}
        cleaner={cleaner}
        cleanerError={cleanerError}
        date={date}
        disabledDateObj={disabledDateObj}
        setDate={setDate}
        setMonth={setMonth}
        settings={settings}
        timeArray={timeArray}
        time_set={(fullTime, Date) => {
          setOrderDetails({
            time_start: Date ? fullTime : null
          });
        }}
      >
        <>
          <CheckOutList
            loading={addressBlackListCheckRes.loading}
            disabled={addressBlackListCheckRes.loading}
          />
          {checkoutError &&
          orderDetails.client_address &&
          !orderDetails.random_cleaner &&
          !orderDetails.cleaner_id ? (
            <span className="checkOutList_wrapper_lg errorMsg">
              {t("Please select a cleaner")}
            </span>
          ) : (
            ``
          )}
          {checkoutError &&
          orderDetails.client_address &&
          !orderDetails.time_start &&
          timeError() ? (
            <span className="checkOutList_wrapper_lg errorMsg">
              {timeError()}
            </span>
          ) : (
            ``
          )}
          <div className="showLg">
            {cartUrlLinkJSX}
          </div>
        </>
      </CheckOutSection>
    </div>
  );
};

const mapStateToProps = (state: stateType) => ({
  orderDetails: state.orderReducer.details,
  cart: state.cartReducer.cart,
  extras: state.cartReducer.extras,
  checkoutError: state.commonReloadReducer.checkoutError,
  addressBlacklisted: state.commonReloadReducer.addressBlacklisted,
  orderInfo: state.orderReducer.orderInfo,
  settings: state.settingsReducer,
  pageCount: state.commonReducer.pageCount
});

const mapDispatchToProps = (dispatch: any) => ({
  setOrderDetails: (details: Partial<orderType>) => {
    dispatch(setOrderDetails(details) as any);
  },
  setAddressBlacklisted: (data: boolean) => {
    dispatch(setAddressBlacklisted(data));
  },
  setPageCount: (data: number) => {
    dispatch(setPageCount(data));
  }
});

const ConnectedCheckOutTime = connect(
  mapStateToProps,
  mapDispatchToProps
)(CheckOutTime);

export default ConnectedCheckOutTime;
